module.exports = __webpack_public_path__ + "static/media/pin.e20cce52.svg";